import { inject, Pipe, PipeTransform } from '@angular/core';

import { DictionariesService } from '../services/dictionaries.service';

@Pipe({
  standalone: true,
  name: 'translateIn',
  pure: false,
})
export class TranslateInPipe implements PipeTransform {
  #dictionariesService = inject(DictionariesService);

  #value: string;
  #lastKey: string;

  transform(
    key: string,
    langCode?: string,
    interpolation?: { [key: string]: any },
  ): string {
    if (this.#lastKey === key && this.#value) {
      return this.#value;
    }

    this.#lastKey = key;

    const value = this.#dictionariesService.translate(
      key,
      langCode,
      interpolation,
    );

    if (value !== key) {
      this.#value = value;
    }

    return value;
  }
}
